import React from "react";
import PropTypes from 'prop-types';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import CircularProgress from '@material-ui/core/CircularProgress';
import TableSortLabel from '@material-ui/core/TableSortLabel';

// core components
import styles from './styles';

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function descObj(a, b, orderBy) {
  //Check property exists on both objects
  if (a.hasOwnProperty(orderBy) !== a.hasOwnProperty(orderBy))
    return 0;

  let value1 = a[orderBy].props.children;
  let value2 = b[orderBy].props.children;
  let result = 0;

  switch (typeof(value1)) {
    //Deep compare objects
    case 'number':
      if (value1 > value2)
        result = -1;
      else {
        if (value1 === value2)
          result = 0;
        else
          result = 1;
      }
      break;
    //Compare function code
    case 'string':
        if (value1.match(/[0-9]+/g))//string contains number 
        {
            var d1 = value1.match(/[0-9]+/g);
            var d2 = value2.match(/[0-9]+/g);
            var d1_len = (null == d1? 0: d1.length);
            var d2_len = (null == d2? 0: d2.length);
            if (0 == d1_len || 0 == d2_len)
            {
                result = value2.localeCompare(value1);
            }
            else
            {
                var min_len = Math.min(d1_len, d2_len);
                for (var i = 0; i < min_len; i++)
                {
                   if (Number(d1[i]) > Number(d2[i])) 
                    {
                        result = -1;
                        break;
                    }
                    else if (Number(d1[i]) < Number(d2[i]))
                    {
                        result = 1;
                        break;
                    }
                    else
                        continue;
                }
                if (0 == result)
                {
                    result = (d1_len == d2_len ? 0: (d1_len > d2_len ? -1: 1));
                }
           }
        }
        else
        {
            result = value2.localeCompare(value1);
        }
        break;
  }

  return result;
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => descObj(a, b, orderBy) : (a, b) => -descObj(a, b, orderBy);
}

function handleNewline(text) {
  if ('object' === typeof (text) && 'p' === text.type) {
    var str = text.props.children;
    var newLineStart = 0;
    var newLineEnd = str.indexOf('\n', newLineStart);
    var content = [];
    if (-1 === newLineEnd) {
      newLineEnd = str.length - 1;
      var line_content = str.substr(newLineStart, (newLineEnd - newLineStart));
      content = [...content, line_content];
      return  React.createElement('p', null, content);
    }
    else {
      var br = React.createElement('br', null, null);

      do {
        var line_content = str.substr(newLineStart, (newLineEnd - newLineStart));

        content = [...content, line_content, br];

        newLineStart = newLineEnd + 1;
        newLineEnd = str.indexOf('\n', newLineStart);
      } while (-1 !== newLineEnd);

      newLineEnd = str.length - 1;
      if (newLineStart < newLineEnd) {
        var line_content = str.substr(newLineStart, (newLineEnd - newLineStart));

        content = [...content, line_content, br];
      }

      return  React.createElement('p', null, content);
    }
  }
  else {
    return text;
  }
}

function CustomTable({ ...props }) {
    const { classes, tableHead, tableData, tableHeaderColor, containerHeight, rowsPerPage, totalCount, page, handleChangePage, isLoading, tableOrder, tableOrderBy} = props;
    const [order, setOrder] = React.useState(tableOrder);
    const [orderBy, setOrderBy] = React.useState(tableOrderBy);
    const handleRequestSort = property => event => {
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    }
    return (
        <div className={classes.wrapperContainer}>
            <div className={classes.tableResponsive} style={{height: containerHeight}}>
                <Table className={classes.table}>
                    {tableHead !== undefined ? (
                        <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
                            <TableRow>
                                {tableHead.map((prop, key) => {
                                    return (
                                        <TableCell
                                        className={classes.tableCell + " " + classes.tableHeadCell}
                                        key={key}
                                        sortDirection={orderBy === key ? order : false}
                                        >
                                            <TableSortLabel
                                             active='true'
                                             direction={order}
                                             onClick={handleRequestSort(key)}
                                            >
                                                {prop}
                                            </TableSortLabel>
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                    ) : null}
                    <TableBody showRowHover={true}>
                        {stableSort(tableData, getSorting(order, orderBy))
                        .slice((page - 1) * rowsPerPage, (page - 1) * rowsPerPage + rowsPerPage)
                        .map((prop, key) => {
                        return (
                            <TableRow key={key} className={prop[prop.length-1].props.children === true ? classes.highlight_row: classes.normal_row}>
                            {prop.map((cell, key) => {
                                if ('boolean' !== typeof(cell.props.children)){ // special status column do not show
                                    return (
                                    <TableCell className={classes.tableCell} key={key}>
                                       {handleNewline(cell)}
                                    </TableCell>
                                    );
                                }
                            })}
                            </TableRow>
                        );
                        })}
                    </TableBody>
                </Table>
                <TablePagination
                    classes={{
                        root: classes.tablePaginationRoot,
                        caption: classes.tablePaginationCaption,
                    }} 
                    rowsPerPageOptions={[rowsPerPage]}
                    component="div"
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={handleChangePage}
                    // onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            </div>
            {
                isLoading &&
                    <CircularProgress size={36} className={classes.loadingProgress} />
            }
        </div>
    );
}
  
CustomTable.defaultProps = {
    tableHeaderColor: "gray",
    containerHeight: 755,
    totalCount: 0,
    rowsPerPage: 10,
    page: 1,
    isLoading: false,
    tableOrder: "asc",
    tableOrderBy: 0,
};
  
CustomTable.propTypes = {
    classes: PropTypes.object.isRequired,
    tableHeaderColor: PropTypes.oneOf([
        "black",
        "warning",
        "primary",
        "danger",
        "success",
        "info",
        "rose",
        "gray"
    ]),
    tableHead: PropTypes.arrayOf([PropTypes.string, PropTypes.object]),
    // tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string | PropTypes.object))
    tableData: PropTypes.arrayOf(PropTypes.arrayOf([PropTypes.string, PropTypes.object]))
};

export default withStyles(styles)(CustomTable);
